// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"ShareDropdown_dropdown__2CRiV","title":"ShareDropdown_title__159NO","socials":"ShareDropdown_socials__mJd59","social":"ShareDropdown_social__1-bR8"};